import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */

export class GetNewsDetailUseCase extends UseCase {
  constructor({httpNewsRepository, config, newsDetailRequestValueObjectFactory}) {
    super({httpNewsRepository, config, newsDetailRequestValueObjectFactory})

    this._httpNewsRepository = httpNewsRepository
    this._newsDetailRequestValueObjectFactory = newsDetailRequestValueObjectFactory
    this._config = config
  }

  @tracer({metric: 'GetNewsDetailUseCase#execute'})
  @inlineError
  async execute({articleId, slug, locale}) {
    const [repositoryError, repositoryResponse] = await this._httpNewsRepository.getDetailInfo(
      this._newsDetailRequestValueObjectFactory({articleId, locale, slug})
    )

    if (repositoryError) return Promise.reject(repositoryError)

    return repositoryResponse.toJSON()
  }
}
